// 首頁
"use client"
import Image from "next/image";
import CRMask from "../CRMask";
import DotAnimation from "../common/DotAnimation";
import { CR_BUSINESS_MAIL, FRONT_CONTENT } from "../common/constant";

const CRFront = () => {

    return(
        <section id="cr-front" className="cr-section cr-front w-full h-screen overflow-hidden asm:min-h-[750px] z-[1]">
            <div className="w-full asm:h-[200vh] h-screen bg-repeat absolute top-0 left-0"></div>
            <div className="w-full h-screen flex justify-center m-auto">
                <div className="front-wrap w-full h-screen asm:pt-[70px]">
                    <div className="section1-wrap w-full h-[calc(100vh-70px)] usm:h-[calc(100vh-70px-70px)] usm:pt-[70px] flex flex-col items-center justify-center asm:w-[1440px] z-[1] m-auto">

                        {/* 人物及遮罩 */}
                        <div className="statue-and-mask section1-mask w-full h-[fit-content] relative ">
                            {/* 影片遮罩 */}
                            <div className="mask-container m-auto w-[1091px] h-[315px] usm:w-full usm:h-[100vw]">
                                <CRMask />
                            </div>
                            {/* 雕像 */}
                            <div className="cr-man cr-statue w-[358px] usm:w-[90vw] h-full flex justify-center items-center absolute m-auto z-[3] left-0 right-0 translate-y-[-105%] translate-x-[50px] usm:translate-x-0 usm:translate-y-[-100%]">
                                <Image
                                    alt="man-image"
                                    width={500}
                                    height={500}
                                    src={"/images/cryptoread/section1/sculpture.png"}
                                    className="aspect-square absolute top-0"
                                />
                            </div>
                        </div>

                        {/* 格線 */}
                        <div className="grid-wrap relative w-full">
                            <Image
                            alt="grid-image"
                            width={2715}
                            height={280}
                            src={"/images/cryptoread/section1/grid.svg"}
                            className="absolute top-0"
                            />
                        </div>

                        {/* 文字 */}
                        <div className="text-content relative z-[1] text-center max-w-[764px] usm:w-[95vw] [&>p]:text-h5 whitespace-pre-wrap mt-[30px] usm:mt-[25px]"> 
                            <p className="text-black">{FRONT_CONTENT?.[0]}</p>
                            <p className="!font-medium !text-[1rem] text-black4 font-[sorts-mill-goudy] mt-[15px] usm:hidden">{FRONT_CONTENT?.[1]}</p>
                        </div>

                        {/* scroll文字 */}
                        <div className="text-scroll asm:py-[30px] z-[1]">
                            <p className="text-[#D3392F] mb-[10px]">scroll</p>
                            <DotAnimation direction="col"/>
                        </div>
                    </div>

                    <div className="cr-section-2 absolute top-0 left-0 w-full h-screen flex flex-col justify-center gap-y-[10vh] z-10">
                        {/* 文字左 */}
                        <div className="text-wrap-left relative w-[2956px] h-[114px] translate-x-[-100%]">
                            <Image
                                alt="text-image"
                                width={2956}
                                height={114}
                                src={"/images/cryptoread/section2/text_1.svg"}
                            />
                        </div>

                        {/* 文字右 */}
                        <div className="text-wrap-right relative w-[2956px] h-[114px] translate-x-[100%]">
                            <Image
                                alt="text-image"
                                width={3093}
                                height={92}
                                src={"/images/cryptoread/section2/text_2.svg"}
                            />
                        </div>
                    </div>
                    <div className="white-bg w-full h-screen bg-white absolute top-0 left-0 z-[3] opacity-0"></div>
                </div>

                {/* 商業合作按鈕 */}
                <Button />
            </div>
        </section>
    )
};

export default CRFront;

{/* 商業合作按鈕 */}
const Button = () =>{
    return(
        <button
            className="business-button usm:hidden !filter-none h-[155px] w-[38px] px-[18px] trans text-btn1 
            absolute top-[75vh] left-[25px] flex center-center pointer-events-auto
            text-white bg-black rounded-[40px] border-1 border-black 
            hover:text-white hover:bg-black7 hover:border-black7"
            onClick={()=>window.location.href=CR_BUSINESS_MAIL}
            style={{writingMode: 'horizontal-tb'}}
        >
            商業合作聯繫
        </button>
    )
}